import { Breadcrumb, Button, Card, Col, Flex, Layout, Row, Select, Space, Table } from "antd";
import { FormDatePicker, FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { MainLayout } from "components/layouts";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import moment from "moment";
import FormItem from "antd/lib/form/FormItem";
import { ReactComponent as DownloadIcon } from "../../../assets/icon/downloadIcon.svg"
import HistoryGroupModal from "./reportModal/HistoryGroupModal";
import TableAntd from "components/elements/Table";
import ReportStatus from "./ReportStatus";

const EmployeeHistoryGroupComponent = ({
    showReport,
    reportTableList = [],
    departmentOptions = [],
    organizationName = [],
    positionOptions = [],
    mobileNumber = [],
    generalInfo = [],
    informationTypeOptions = [],
    initialValues,
    pagination,
    employmentType = [],
    employeeTypeOptions = [],
    employeeStatusTypeOptions = [],
    employmentTypeOptions = [],
    handleSearch = () => { },
    onChange = () => { },
    exportEmployeeRegistrationReport = () => { },
    isModalOpen = false,
    setIsModalOpen = () => { },
    showModal = () => { },
    handleDateChange = () => { },
    isDownloading
}) => {
    const { t, i18n } = useTranslation();
    const companyMock = [{ label: "ข้อมูลพื้นฐาน", value: "1" }]

    function formatDate(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "DD/MM/YYYY" : `DD/MM/${date.year() + 543}`);
    }

    function formatTime(dateString) {
        if (!dateString) return;
        const date = dayjs(dateString);
        return date.format(i18n.language === "en" ? "HH:mm" : `HH:mm น.`);
    }

    function getAge() {
        const now = dayjs();
        let age = now.diff(generalInfo?.dateOfBirth, 'year');
        return age
    }

    const calculateWorkDuration = (startDateStr) => {
        const startDate = moment(startDateStr);
        const currentDate = moment();

        const years = currentDate.diff(startDate, 'years');
        startDate.add(years, 'years');

        const months = currentDate.diff(startDate, 'months');
        startDate.add(months, 'months');

        const days = currentDate.diff(startDate, 'days');

        if (years < 0 || months < 0 || days < 0) {
            return '-';
        }

        return `${years} ปี ${months} เดือน ${days} วัน`;
    };

    const columns = [
        {
            title: <div className="text-table">{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            align: "center",
            width: 100,
            render: (_, record, idx) => {
                return <span style={{ color: "#667085" }}>{(pagination.pageNo - 1) * pagination.size + idx + 1}</span>;
            },
        },
        {
            title: <div className="text-table">{t('report.employeeNo')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            align: "center",
            width: 130,
            render: (_, record) => {
                if (record?.employeeNo === null || record?.employeeNo === undefined || record?.employeeNo === "") {
                    return "-";
                }
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "20px",
                        width: "max-content",
                        height: "30px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px 16px"
                    }}
                >
                    {record?.employeeNo}
                </span>;
            },
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "name",
            key: "name",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.name ? record?.name + " " + record?.surName : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('common.nick-name')}</div>,
            dataIndex: "nickName",
            key: "nickName",
            align: "left",
            width: 150,
            render: (_, record) => {
                return record?.nickName ? record?.nickName : "-";
            },
        },
        {
            title: <div className="text-table">{t('name-surname-en')}</div>,
            dataIndex: "nameEn",
            key: "nameEn",
            align: "left",
            width: 250,
            render: (_, record) => {
                return (record?.nameEn ? record?.nameEn + " " + record?.surNameEn : "-")
            },
        },
        {
            title: <div className="text-table">{t('nickname-en')}</div>,
            dataIndex: "nickNameEn",
            key: "nickNameEn",
            align: "left",
            width: 150,
            render: (_, record) => {
                return record?.nickNameEn ? record?.nickNameEn : "-";
            },
        },
        {
            title: <div className="text-table">{t('employee.company')}</div>,
            dataIndex: "companyId",
            key: "companyId",
            align: "left",
            width: 230,
            render: (_, record) => {
                if (record?.companyId?.name != null) {
                    return i18n.language === "en" ? record?.companyId?.nameEn : record?.companyId?.name;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('report.branch')}</div>,
            dataIndex: "branchInformation",
            key: "branchInformation",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (record?.branchInformation?.name != null) {
                    return i18n.language === "en" ? record?.branchInformation?.nameEn : record?.branchInformation?.name;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('department')}</div>,
            dataIndex: "department",
            key: "department",
            align: "left",
            width: 250,
            render: (_, record) => {
                const department = record?.department?.map?.((department) => {
                    return i18n.language === "en" ? department?.organizationNameEn : department?.organizationName;
                });
                return department?.join(", ");
            },
        },
        {
            title: <div className="text-table">{t('report.position')}</div>,
            dataIndex: "position",
            key: "position",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.position?.nameEn;
                }
                return record?.position?.name;
            },
        },
        {
            title: <div className="text-table">{t('employee-type')}</div>,
            dataIndex: "employeeType",
            key: "employeeType",
            align: "left",
            width: 150,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.employeeType?.nameEn;
                }
                return record?.employeeType?.name;
            },
        },
        {
            title: <div className="text-table">{t('type-of-employment')}</div>,
            dataIndex: "employmentType",
            key: "employmentType",
            align: "left",
            width: 200,
            render: (_, record) => {
                if (record?.employmentType?.name != null) {
                    return i18n.language === "en" ? record?.employmentType?.nameEn : record?.employmentType?.name;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('work-start-date')}</div>,
            dataIndex: "employmentDate",
            key: "employmentDate",
            align: "left",
            width: 150,
            render: (_, record) => {
                return record?.employmentDate ? formatDate(record?.employmentDate) : "-";
            },
        },
        {
            title: <div className="text-table">{t('packing-date')}</div>,
            dataIndex: "probationDate",
            key: "probationDate",
            align: "left",
            width: 150,
            render: (_, record) => {
                return record?.probationDate ? formatDate(record?.probationDate) : "-";
            },

        },
        {
            title: <div className="text-table">{t('years-experience ')}</div>,
            dataIndex: "yearExperience",
            key: "yearExperience",
            align: "left",
            width: 150,
            render: (_, record) => {
                return record?.employmentDate ? calculateWorkDuration(record?.employmentDate) : '-'
            }
        },
        {
            title: <div className="text-table">{t('identification-no')}</div>,
            dataIndex: "identificationNo",
            key: "identificationNo",
            align: "center",
            width: 250,
            render: (_, record) => {
                return (
                    record?.identificationNo
                )
            }
        },
        {
            title: <div className="text-table">{t('employee.nationality')}</div>,
            dataIndex: "nationality",
            key: "nationality",
            align: "center",
            width: 100,
            render: (_, record) => {
                if (i18n.language === "en") {
                    return record?.nationality?.nameEn;
                }
                return record?.nationality?.name;
            },
        },
        {
            title: <div className="text-table">{t('birth-date')}</div>,
            dataIndex: "dateOfBirth",
            key: "dateOfBirth",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record?.dateOfBirth ? formatDate(record?.dateOfBirth) : "-";
            },
        },
        {
            title: <div className="text-table">{t('employee.age-0')}</div>,
            dataIndex: "age",
            key: "age",
            width: 100,
            align: "center",
            render: (_, record) => {
                const now = dayjs();
                let getAge = now.diff(record?.dateOfBirth, 'year');
                return getAge
            }
        },
        {
            title: <div className="text-table">{t('report.mobile-number')}</div>,
            dataIndex: "mobileNumber",
            key: "mobileNumber",
            align: "center",
            width: 150,
            render: (_, record) => {
                return record?.mobileNumber ? record?.mobileNumber : "-"
            },
        },
        {
            title: <div className="text-table">{t('employee.label.email')}</div>,
            dataIndex: "email",
            key: "email",
            align: "left",
            width: 300,
            render: (_, record) => {
                return (
                    record?.email ? record?.email : "-"
                )
            },
        },
        {
            title: <div className="text-table">{t('register-address')}</div>,
            dataIndex: "registerAddress",
            key: "registerAddress",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (record?.registerAddress !== null) {
                    return i18n.language === "En" ? record?.registerAddressEn : record?.registerAddress;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('report.address')}</div>,
            dataIndex: "address",
            key: "address",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (record?.address !== null) {
                    return i18n.language === "en" ? record?.addressEn : record?.address;
                }
                return "-"
            },
        },
        {
            title: <div className="text-table">{t('bank.header')}</div>,
            dataIndex: "financial",
            key: "financial",
            align: "left",
            width: 250,
            render: (_, record) => {
                if (record?.financial?.bankName !== null) {
                    return i18n.language === "en" ? record?.financial?.bankNameEn : record?.financial?.bankName
                }
                return "-"
            }
        },
        {
            title: <div className="text-table">{t('bank-account-no')}</div>,
            dataIndex: "bankAccountNo",
            key: "bankAccountNo",
            align: "left",
            width: 200,
            render: (_, record) => {
                return (
                    record?.financial?.bankAccountNo ? record?.financial?.bankAccountNo : "-"
                )
            }
        },
        {
            title: <div className="text-table">{t('translation.status')}</div>,
            dataIndex: "employeeStatus",
            key: "employeeStatus",
            align: "center",
            width: 200,
            render: (_, record) => {
                if (record?.employeeStatus) {
                    if (i18n.language === "en") {
                        return <ReportStatus value={record?.employeeStatus?.nameEn} />;
                    }
                    return <ReportStatus value={record?.employeeStatus?.name} />;
                }
                return "-"
            },
        },
    ];

    const scrollX = columns.reduce((sum, column) => sum + (column.width || 0), 0);
    return (
        <>
            <HistoryGroupModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                exportEmployeeRegistrationReport={exportEmployeeRegistrationReport}
                isDownloading={isDownloading}
            />
            <Space style={{ width: "100%", rowGap: 24 }} direction="vertical" >
                <Flex vertical>
                    <Breadcrumb items={[
                        { title: t("home.header"), href: "/" },
                        { title: t('report.header'), href: "" },
                        { title: t('translation.employee-history-group-0'), href: "" },
                        { title: t('employee-registration-report') },

                    ]} />
                    <h2>{t("employee-registration-report")}</h2>
                </Flex>
                <FormAntd
                    // form={form}
                    initialValues={{ ...initialValues }}
                    onFinish={handleSearch}
                // requiredMark={RequiredMark}
                // colon={false}
                >
                    <FormItem shouldUpdate={(prev, curv) => {
                        return false
                    }}>
                        {({ getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <>
                                    <Card style={{
                                        backgroundColor: "white",
                                        width: "100%",
                                        marginBottom: "1vw",
                                        border: "1px solid #EAECF0",
                                    }}>
                                        <Flex vertical style={{ rowGap: "24px" }}>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeNo"
                                                        label={t("employee.label.employee_no")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormInput
                                                        name="employeeFullName"
                                                        label={t("name-surname")}
                                                        size="large"
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="departmentId"
                                                        label={t('employee.label.department')}
                                                        options={departmentOptions}
                                                        allowClear
                                                        multiple={true}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="positionId"
                                                        // mode="multiple"
                                                        multiple={true}
                                                        label={t('position.header')}
                                                        options={positionOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('report.please_select')}
                                                        size="large"
                                                        tree={true}
                                                    // onChange={handleChange}
                                                    // options={options}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employmentType"
                                                        label={t("salary.label.employment_type")}
                                                        size="large"
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        mode="multiple"
                                                        placeholder={t('report.please_select')}
                                                        options={employmentTypeOptions}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormSelect
                                                        name="employeeStatusId"
                                                        // mode="multiple"
                                                        label={t('employee.label.employee_status')}
                                                        options={employeeStatusTypeOptions}
                                                        allowClear
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        mode="multiple"
                                                        placeholder={t('report.all')}
                                                        size="large"
                                                    // onChange={handleChange}
                                                    // options={options}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row gutter={24} style={{ marginLeft: "0px" }}>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDate"
                                                        type="range"
                                                        label={t('start-work-date-to-end-date')}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('start-work-date-to-end-date')}
                                                        size="large"
                                                        onChange={handleDateChange}
                                                    />
                                                </Col>
                                                <Col span={8}>
                                                    <FormDatePicker
                                                        name="startToEndDateExpire"
                                                        type="range"
                                                        label={t('วันที่พ้นสภาพ')}
                                                        style={{
                                                            width: '100%',
                                                        }}
                                                        placeholder={t('วันที่พ้นสภาพ')}
                                                        size="large"
                                                    // onChange={handleDateChange}
                                                    />
                                                </Col>
                                            </Row>

                                            <Row gutter={[24, 16]} style={{ justifyContent: "end", display: "flex", gap: "16px" }}>
                                                <Button type="default" onClick={() => { resetFields() }} style={{ borderRadius: "8px", height: "40px" }}>
                                                    {t("common.clear").toUpperCase()}
                                                </Button>
                                                <Button type="primary" htmlType="submit" style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color)", boxShadow: "none" }}>
                                                    {t("creatTamplete.Search").toUpperCase()}
                                                </Button>
                                            </Row>
                                        </Flex>
                                    </Card>

                                    {
                                        showReport && (
                                            <Space direction="vertical" size={16}>
                                                <Flex justify="end">
                                                    <Button type="default" style={{ height: "40px", borderRadius: "8px" }} onClick={showModal}>
                                                        <Flex gap={8}>
                                                            <DownloadIcon />
                                                            <span style={{ color: "#59687F" }}>{t("report.downlod_doc")}</span>
                                                        </Flex>
                                                    </Button>
                                                </Flex>
                                                <Card style={{
                                                    backgroundColor: "white",
                                                    width: "100%",
                                                    border: "1px solid #EAECF0",
                                                }}>
                                                    <Space direction="vertical" size={8}>
                                                        <span style={{ fontSize: "1vw", fontWeight: "bold" }}>{t('employee-registration-report')}</span>
                                                        <TableAntd
                                                            columns={columns}
                                                            dataSource={reportTableList}
                                                            rowKey={(record) => record.id}
                                                            scroll={{ x: scrollX }}
                                                            tableLayout="fixed"
                                                            pagination={pagination}
                                                            onChange={onChange}
                                                        />
                                                    </Space>
                                                </Card>
                                            </Space>
                                        )
                                    }
                                </>
                            );
                        }}
                    </FormItem>

                </FormAntd>

            </Space>
        </>
    );
}

export default EmployeeHistoryGroupComponent;
